import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
type PlayPermissionDialogProps = {
  open?: boolean;
  hide: () => void;
  onAllow: () => void;
};
const PlayPermissionDialog = t0 => {
  const $ = _c(18);
  const {
    open,
    hide,
    onAllow
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "document-flow.components.camera.play-permission-dialog"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const t2 = !!open;
  let t3;
  if ($[1] !== t) {
    t3 = t(_temp);
    $[1] = t;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp2);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== onAllow || $[6] !== t4) {
    t5 = {
      label: t4,
      onClick: onAllow
    };
    $[5] = onAllow;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t) {
    t6 = t(_temp3);
    $[8] = t;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <p className="text-body-2 text-secondary text-center fp-text">{t6}</p>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== hide || $[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t7) {
    t8 = <Dialog open={t2} title={t3} onClose={hide} size="compact" primaryButton={t5} isConfirmation={true}>{t7}</Dialog>;
    $[12] = hide;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export default PlayPermissionDialog;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.cta;
}
function _temp3($_1) {
  return $_1.description;
}